// eslint-disable-next-line
const UsaStates = require("usa-states").UsaStates;

// export const usaStates = new UsaStates({ includeTerritories: true }).states;
export const usaStates = new UsaStates().states;

// Any-cased abbreviation or full name ("ca", "CA", "california") -> "California"; anything else -> null.
export const convertStateToFullName = (stateValue) => {
  const lower = String(stateValue ?? "")
    .trim()
    .toLowerCase();
  const match = usaStates.find(
    (state) => state.name.toLowerCase() === lower || state.abbreviation.toLowerCase() === lower
  );
  return match ? match.name : null;
};

export const usaStatesListItems = [
  { title: "Alabama", value: "Alabama" },
  { title: "Alaska", value: "Alaska" },
  { title: "Arizona", value: "Arizona" },
  { title: "Arkansas", value: "Arkansas" },
  { title: "California", value: "California" },
  { title: "Colorado", value: "Colorado" },
  { title: "Connecticut", value: "Connecticut" },
  { title: "Delaware", value: "Delaware" },
  { title: "Florida", value: "Florida" },
  { title: "Georgia", value: "Georgia" },
  { title: "Hawaii", value: "Hawaii" },
  { title: "Idaho", value: "Idaho" },
  { title: "Illinois", value: "Illinois" },
  { title: "Indiana", value: "Indiana" },
  { title: "Iowa", value: "Iowa" },
  { title: "Kansas", value: "Kansas" },
  { title: "Kentucky", value: "Kentucky" },
  { title: "Louisiana", value: "Louisiana" },
  { title: "Maine", value: "Maine" },
  { title: "Maryland", value: "Maryland" },
  { title: "Massachusetts", value: "Massachusetts" },
  { title: "Michigan", value: "Michigan" },
  { title: "Minnesota", value: "Minnesota" },
  { title: "Mississippi", value: "Mississippi" },
  { title: "Missouri", value: "Missouri" },
  { title: "Montana", value: "Montana" },
  { title: "Nebraska", value: "Nebraska" },
  { title: "Nevada", value: "Nevada" },
  { title: "New Hampshire", value: "New Hampshire" },
  { title: "New Jersey", value: "New Jersey" },
  { title: "New Mexico", value: "New Mexico" },
  { title: "New York", value: "New York" },
  { title: "North Carolina", value: "North Carolina" },
  { title: "North Dakota", value: "North Dakota" },
  { title: "Ohio", value: "Ohio" },
  { title: "Oklahoma", value: "Oklahoma" },
  { title: "Oregon", value: "Oregon" },
  { title: "Pennsylvania", value: "Pennsylvania" },
  { title: "Rhode Island", value: "Rhode Island" },
  { title: "South Carolina", value: "South Carolina" },
  { title: "South Dakota", value: "South Dakota" },
  { title: "Tennessee", value: "Tennessee" },
  { title: "Texas", value: "Texas" },
  { title: "Utah", value: "Utah" },
  { title: "Vermont", value: "Vermont" },
  { title: "Virginia", value: "Virginia" },
  { title: "Washington", value: "Washington" },
  { title: "West Virginia", value: "West Virginia" },
  { title: "Wisconsin", value: "Wisconsin" },
  { title: "Wyoming", value: "Wyoming" },
  { title: "District of Columbia", value: "District of Columbia" },
];

export const usaStatesAbbreviationItems = [
  { title: "AL", value: "AL" },
  { title: "AK", value: "AK" },
  { title: "AZ", value: "AZ" },
  { title: "AR", value: "AR" },
  { title: "CA", value: "CA" },
  { title: "CO", value: "CO" },
  { title: "CT", value: "CT" },
  { title: "DE", value: "DE" },
  { title: "FL", value: "FL" },
  { title: "GA", value: "GA" },
  { title: "HI", value: "HI" },
  { title: "ID", value: "ID" },
  { title: "IL", value: "IL" },
  { title: "IN", value: "IN" },
  { title: "IA", value: "IA" },
  { title: "KS", value: "KS" },
  { title: "KY", value: "KY" },
  { title: "LA", value: "LA" },
  { title: "ME", value: "ME" },
  { title: "MD", value: "MD" },
  { title: "MA", value: "MA" },
  { title: "MI", value: "MI" },
  { title: "MN", value: "MN" },
  { title: "MS", value: "MS" },
  { title: "MO", value: "MO" },
  { title: "MT", value: "MT" },
  { title: "NE", value: "NE" },
  { title: "NV", value: "NV" },
  { title: "NH", value: "NH" },
  { title: "NJ", value: "NJ" },
  { title: "NM", value: "NM" },
  { title: "NY", value: "NY" },
  { title: "NC", value: "NC" },
  { title: "ND", value: "ND" },
  { title: "OH", value: "OH" },
  { title: "OK", value: "OK" },
  { title: "OR", value: "OR" },
  { title: "PA", value: "PA" },
  { title: "RI", value: "RI" },
  { title: "SC", value: "SC" },
  { title: "SD", value: "SD" },
  { title: "TN", value: "TN" },
  { title: "TX", value: "TX" },
  { title: "UT", value: "UT" },
  { title: "VT", value: "VT" },
  { title: "VA", value: "VA" },
  { title: "WA", value: "WA" },
  { title: "WV", value: "WV" },
  { title: "WI", value: "WI" },
  { title: "WY", value: "WY" },
  { title: "DC", value: "DC" },
];
